import { motion } from "framer-motion";
import bspPics from "@assets/bsp_pics_2_1920.jpg";

export function About() {

  return (
    <section id="about" className="py-32 relative bg-zinc-950">
      <div className="container mx-auto px-6">
        <div className="grid grid-cols-1 lg:grid-cols-5 gap-12 lg:gap-16 mb-24 items-center">
          <motion.div 
            initial={{ opacity: 0, y: 30 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true, amount: 0.15 }}
            transition={{ duration: 0.8 }}
            className="lg:col-span-2 space-y-6"
          >
            <p className="text-2xl md:text-3xl font-bold text-white leading-snug">
              Recent winners of the first-ever Creative Impact Award at the Wales Business Awards 2026 and winners at BAFTA qualifying Focus Wales Film Festival and Wales International Film Festival. Winners of Media & Entertainment at UK StartUp Awards 2024.
            </p>
          </motion.div>

          <motion.div 
            initial={{ opacity: 0, scale: 0.95 }}
            whileInView={{ opacity: 1, scale: 1 }}
            viewport={{ once: true, amount: 0.15 }}
            transition={{ duration: 1, delay: 0.2 }}
            className="lg:col-span-3 relative"
          >
            <div className="aspect-video overflow-hidden rounded-sm relative">
              <img loading="lazy" decoding="async" 
                src={bspPics} 
                alt="Black Swan Productions team" 
                className="w-full h-full object-cover object-center"
              />
            </div>
          </motion.div>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-x-16 gap-y-16 mt-24 border-t border-white/10 pt-16">
          <motion.div
            initial={{ opacity: 0, y: 30 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true }}
            transition={{ duration: 0.6 }}
            className="space-y-4"
          >
            <h2 className="font-display text-2xl font-bold text-white">Brand Stand</h2>
            <p className="text-gray-400 leading-relaxed">
              This is our flagship corporate video service, where we produce video podcasts for businesses. This is created to evolve both marketing and business development by putting real people front and centre of brands. It produces consistent, high-quality long-form and short-form video content that helps brands share their personalities and expertise - building stronger connections, greater authority, and lasting thought leadership.
            </p>
          </motion.div>

          <motion.div
            initial={{ opacity: 0, y: 30 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true }}
            transition={{ duration: 0.6, delay: 0.1 }}
            className="space-y-4"
          >
            <h2 className="font-display text-2xl font-bold text-white">Promotional Videos</h2>
            <p className="text-gray-400 leading-relaxed">
              Our calling card for over 5 years. Particularly popular with Welsh SMEs looking to promote a specific business effort by using a high-impact promo video that can be used in marketing and sales efforts. This is where we work out your unique selling points and brand values, and use storytelling to convey a message that leaves an undeniable feeling and actionable intent.
            </p>
          </motion.div>

          <motion.div
            initial={{ opacity: 0, y: 30 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true }}
            transition={{ duration: 0.6, delay: 0.2 }}
            className="space-y-4"
          >
            <h2 className="font-display text-2xl font-bold text-white">Part of Your Team</h2>
            <p className="text-gray-400 leading-relaxed">
              When we work with brands, we tend to work with them for years, noting Welsh businesses like de Novo Solutions, Credas Technologies, NHS Wales, and SinclairsLaw who we have had years of success with across various projects. Whether you're an entrepreneur leading a business or someone leading a marketing department, we'll become part of your team. We pride ourselves on being fun and welcoming collaborators who love to brainstorm ideas.
            </p>
          </motion.div>

          <motion.div
            initial={{ opacity: 0, y: 30 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true }}
            transition={{ duration: 0.6, delay: 0.3 }}
            className="space-y-4"
          >
            <h2 className="font-display text-2xl font-bold text-white">Welsh Language</h2>
            <p className="text-gray-400 leading-relaxed">
              As a Welsh business ourselves, ensuring our projects have a Welsh identity is important. There's something unique about businesses that fly the flag of the dragon, but it's not just about having a certain flair, flow, taste, passion, energy and impression - it's about the language itself. Our team has bilingual speakers that ensure we can tell stories in our native language. If you're looking to produce your project in Welsh, we're here to help.
            </p>
          </motion.div>

          <motion.div
            initial={{ opacity: 0, y: 30 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true }}
            transition={{ duration: 0.6, delay: 0.4 }}
            className="space-y-4 md:col-span-2 text-center"
          >
            <h2 className="font-display text-2xl font-bold text-primary">Scripted Productions</h2>
            <p className="text-gray-400 leading-relaxed max-w-3xl mx-auto">
              Under Black Swan Films in particular, we develop original, unique, and daring psychological horror productions. For example, our self-funded psychological horror short, Control Room, has won awards at BAFTA-qualifying festivals including Focus Wales and Wales International Film Festival, outperforming projects with far greater budgets. Our films focus on exploring Jungian psychology and specific subject areas such as the shadow, persona, and unconscious. Alongside working towards feature film productions with a Welsh identity, we are also currently working on our first vertical micro drama project, the first in Wales, and one of the first originals in the UK under our new Black Swan Verticals entity.
            </p>
          </motion.div>
        </div>
      </div>
    </section>
  );
}
